module.exports = __webpack_public_path__ + "static/media/LogoManyLogin.4004c96d.svg";